import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { SharedField } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getAllSharedFields: QueryFunction<
  SharedField[],
  ['/shared-document-fields']
> = async () => {
  if (isMockServices()) return await mock(_mockSharedFields);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ externalFields: SharedField[] }>(
    '/external-fields?source=Encompass',
    {
      method: 'GET',
    },
  );
  if (response.data)
    return response.data.externalFields.map((field) => ({
      ...field,
      code: field.id,
      fieldType: 'text',
      documentTypeId: '',
      name: field.name.replace(/_/g, ' '),
      displayName: field.name.replace(/_/g, ' '),
      required: false,
    }));
  throw new Error('Failed to fetch shared fields');
};

export default getAllSharedFields;

export const _mockSharedFields = [
  {
    displayName: 'Borrower',
    name: 'borrower',
  },
  {
    displayName: 'Purpose',
    name: 'purpose',
  },
  {
    displayName: 'Loan Officer',
    name: 'loan_officer',
  },
  {
    displayName: 'Amount',
    name: 'amount',
  },
  {
    displayName: 'Credit Score',
    name: 'credit_score',
  },
  {
    displayName: 'Completion Percentage',
    name: 'completion_percentage',
  },
].map((field, index) => ({
  ...field,
  id: `field-${index}`,
  documentTypeId: `document-type-id-${index}`,
  fieldType: 'text' as const,
  code: `field-${index}`,
  required: false,
}));
